var React = require('react');

function Slider (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"#ff4628","height":"32","rx":"16","width":"150","key":0}),React.createElement("g",{"stroke":"#fff","key":1},[React.createElement("path",{"d":"m75 9.90476v12.19044","strokeWidth":"2","key":0}),React.createElement("path",{"d":"m83 9.90476v12.19044","strokeWidth":"2","key":1}),React.createElement("path",{"d":"m67 9.90476v12.19044","strokeWidth":"2","key":2}),React.createElement("path",{"d":"m126 11 6 5-6 5","strokeWidth":"1.5","key":3}),React.createElement("path",{"d":"m24 21-6-5 6-5","strokeWidth":"1.5","key":4})])]);
}

Slider.defaultProps = {"fill":"none","height":"32","viewBox":"0 0 150 32","width":"150"};

module.exports = Slider;

Slider.default = Slider;
